import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "MainPageBackground" }
const _hoisted_2 = { class: "TopBar" }
const _hoisted_3 = { class: "TopBarContent" }
const _hoisted_4 = { class: "Logo" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "home-particles" }
const _hoisted_7 = {
  id: "section-1",
  class: "full-page-section content-section"
}
const _hoisted_8 = { class: "decorative-sidebar" }
const _hoisted_9 = { class: "product-left" }
const _hoisted_10 = { class: "product-image-wrapper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "product-right" }
const _hoisted_13 = { class: "game-title" }
const _hoisted_14 = { class: "game-subtitle" }
const _hoisted_15 = { class: "game-desc" }
const _hoisted_16 = { class: "highlight" }
const _hoisted_17 = { class: "game-list-sidebar" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "info-boxes-wrapper"
}
const _hoisted_21 = {
  key: 1,
  class: "info-boxes-wrapper empty-announcement"
}
const _hoisted_22 = { class: "about-panel-container" }
const _hoisted_23 = { class: "about-navigation" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "card-num" }
const _hoisted_26 = { class: "card-title-group" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = { class: "card-subtitle" }
const _hoisted_29 = { class: "about-details-content" }
const _hoisted_30 = { class: "viewport-main-title" }
const _hoisted_31 = { class: "row-header" }
const _hoisted_32 = { class: "row-title" }
const _hoisted_33 = { class: "row-description" }
const _hoisted_34 = {
  key: 0,
  class: "all-list-overlay"
}
const _hoisted_35 = { class: "all-list-box" }
const _hoisted_36 = { class: "all-list-scroll" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "simple-info" }

import { ref, watch, onMounted, onUnmounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router"; // 라우터 API 임포트
import useGlobalStateStore, { Enum_Theme } from "@/Store/GlobalStateStore";
import InfoBox_Left from "@/components/InfoBox_Left.vue";
import AnnouncementModal from "@/components/AnnouncementModal.vue";
import { AnOutlinedBilibili, AnOutlinedX, MdEmail, SiSinaweibo, CoBrandYoutube, AnOutlinedClose } from "@kalimahapps/vue-icons";
import { fetchAnnouncements } from "@/server/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainPage_KOR',
  setup(__props) {

_useCssVars(_ctx => ({
  "v82a2db5c": (ThemeTopBarBackgroundColor.value),
  "a047b33c": (activeSection.value === 0 ? "none" : "0 2px 4px rgba(0, 0, 0, 0.15)"),
  "v5f259320": (ThemeTopBarColor.value),
  "v42cdc32a": (ThemeItemColor.value),
  "v889c7912": (ThemeHintColor.value),
  "af0986d6": (ThemeMainSloganCruxColor.value),
  "v703cf6c7": (ThemeMainSloganColor.value),
  "v48579e99": (ThemeSubSlogan.value),
  "aad9c49a": (ThemeIconBackgroundHoverColor.value),
  "f8b2b416": (ThemeBottomBG.value),
  "v508f805a": (ThemeBottomPartingLine.value),
  "v84fe700a": (ThemeCopyrightFiling.value)
}))

const GlobalStyleStore = useGlobalStateStore();
const activeSection = ref(0);
const scrollContainer = ref<HTMLElement | null>(null);

const route = useRoute();
const router = useRouter();

const isModalVisible = ref(false);
const currentAnnouncementData = ref<any>(null);

function openAnnouncementModal(item: any) {
  currentAnnouncementData.value = item;
  isModalVisible.value = true;

  // 뉴스 ID를 URL 파라미터에 동기화
  router.replace({ query: { ...route.query, news_id: item.id } });
}

function closeAnnouncementModal() {
  isModalVisible.value = false;

  // URL에서 news_id 파라미터 제거
  const currentQuery = { ...route.query };
  delete currentQuery.news_id;
  router.replace({ query: currentQuery });
}

const ThemeTopBarBackgroundColor = ref("transparent");
const ThemeTopBarColor = ref("#fff");
const ThemeItemColor = ref("#57E1D9");
const ThemeMainSloganColor = ref("#FFF");
const ThemeMainSloganCruxColor = ref("#57E1D9");
const ThemeSubSlogan = ref("#FFF");
const ThemeIconBackgroundColor = ref("#3fb7b0");
const ThemeIconBackgroundHoverColor = ref("#57E1D9");
const ThemeBottomBG = ref("#242424");
const ThemeBottomPartingLine = ref("#FFFFFF26");
const ThemeCopyrightFiling = ref("#FFF");
const ThemeHintColor = ref("#FFF");

// --- 3D Parallax Logic ---
const mouseX = ref(0);
const mouseY = ref(0);
const isHoveringHome = ref(false);

function onHomeMouseMove(e: MouseEvent) {
  isHoveringHome.value = true;
  const { innerWidth, innerHeight } = window;
  mouseX.value = (e.clientX / innerWidth - 0.5) * 2;
  mouseY.value = (e.clientY / innerHeight - 0.5) * 2;
}

function onHomeMouseLeave() {
  isHoveringHome.value = false;
  mouseX.value = 0;
  mouseY.value = 0;
}

const homeBgLayers = computed(() => {
  const moveX = mouseX.value;
  const moveY = mouseY.value;

  const config = [
    { mult: 0.4, scale: 1.02, opacity: 0.35, blur: '6px', blend: 'normal', hue: 0 },
    { mult: 0.8, scale: 1.06, opacity: 0.50, blur: '3px', blend: 'normal', hue: 15 },
    { mult: 1.3, scale: 1.10, opacity: 0.90, blur: '0px', blend: 'normal', hue: 0 },
    { mult: 2.0, scale: 1.16, opacity: 0.40, blur: '2px', blend: 'screen', hue: -15 },
    { mult: 2.8, scale: 1.25, opacity: 0.25, blur: '10px', blend: 'color-dodge', hue: 30 }
  ];

  return config.map((layer, index) => {
    const x = moveX * layer.mult * 1.5;
    const y = moveY * layer.mult * 1.5;
    return {
      transform: `scale(${layer.scale}) translate(${-x}%, ${-y}%)`,
      transition: isHoveringHome.value ? 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'transform 2.5s ease-out',
      backgroundImage: "url('/Images/HomeBG.jpg')",
      opacity: layer.opacity,
      filter: `blur(${layer.blur}) hue-rotate(${layer.hue}deg)`,
      mixBlendMode: layer.blend as any,
      zIndex: index + 1
    };
  });
});

// --- Section 3: "About Us" Data (Korean Translated) ---
const activeAboutTab = ref(0);
const aboutTabsData = [
  {
    num: "01",
    title: "총칙",
    subTitle: "GENERAL",
    paragraphs: [
      { label: "기업 소개", desc: "2021년에 설립된 LESJEUXA는 차세대 게임 크리에이티브 기업으로서, \"기술 연구 개발, 예술적 창조, 새로운 문화 전파\"를 핵심 가치로 삼아 아시아와 전 세계에 뛰어난 혁신적 「유시 솔루션(LESJEUXA Solutions)」을 제공하기 위해 최선을 다하고 있습니다." },
      { label: "취지 및 사명", desc: "취지: 최첨단 기술을 기반으로 예술적 창의성을 통해 문화적 활력을 자극하고, 게임 산업과 문화 교류의 경계를 허무는 융합을 추진합니다.\n사명: 기술 혁신으로 제품 개발을 주도하고, 예술적 표현을 통해 인류의 이념을 전달하며, 뉴미디어와 다각적 플랫폼을 통해 글로벌 영향력을 지닌 새로운 문화를 전파합니다." },
      { label: "비전", desc: "새로운 시대마다 글로벌 게임 크리에이티브와 문화 전파를 선도하는 선구적 기업으로 성장하여 기술과 예술의 완벽한 융합을 실현하고, 개방적이며 공유와 공동 창작이 가능한 디지털 생태계를 구축하여 인류가 진정한 메타버스와 디지털 생명을 실현하는 꿈을 돕겠습니다." }
    ]
  },
  {
    num: "02",
    title: "강령",
    subTitle: "CREED",
    paragraphs: [
      { label: "기술 연구 개발", desc: "우리는 기술을 선도적 가치로 삼아 인공지능, 블록체인, 가상현실 등의 분야에서 돌파구를 마련하며 게임과 메타버스의 혁신을 추진하고 새로운 기술과 방법을 끊임없이 탐구합니다. 연구 개발 성과의 상용화와 실질적 응용에 집중하여 전 세계 사용자에게 안전하고 원활하며 혁신적인 「유시 개념」을 제공합니다." },
      { label: "예술적 창조", desc: "우리는 예술적 다양성을 존중하고 창의적 잠재력을 자극하며, 이종 산업 간의 협력을 장려하여 전통문화와 현대 미술, 게임 디자인의 융합을 실현합니다. 오리지널 정신을 바탕으로 독창적인 스타일의 게임 세계와 시각적 표현을 창조하여 독특한 미적 체험을 전달합니다." },
      { label: "새로운 문화 전파", desc: "우리는 개방적이고 포용적인 태도로 문화 교류를 촉진하며, 다양한 플랫폼과 형식을 통해 시대정신에 부합하는 새로운 문화적 이념을 전파합니다. 디지털 미디어와 소셜 네트워크를 활용하여 글로벌 사용자들이 우수한 문화 콘텐츠와 혁신적인 경험을 공유할 수 있도록 합니다." }
    ]
  },
  {
    num: "03",
    title: "실행 및 관리",
    subTitle: "ACTION",
    paragraphs: [
      { label: "혁신 주도", desc: "우리는 학제 간, 분야 간 혁신 팀을 구성하여 기술과 예술의 심도 있는 융합을 장려하고 미래 트렌드에 부합하는 게임 제품과 문화 프로젝트를 만듭니다. 다양한 형태의 창의적 교류와 업계 세미나 활동에 적극적으로 참여하여 구성원 전체의 창의성과 협업 정신을 고취합니다." },
      { label: "제도적 보장", desc: "우리의 프로젝트 관리는 인류 역사상 가장 투명한 영미법(Common Law) 체계를 기반으로 작성된 규칙에 따라 실행됩니다. 연구 개발, 창작 및 전파의 완벽한 표준을 수립하여 각 단계의 업무가 효율적이고 규격화되어 진행되도록 보장합니다. 격려 및 피드백 메커니즘을 구축하여 구성원들이 혁신하고 끊임없이 초월할 수 있는 선순환적 기업 문화를 조성합니다." },
      { label: "시장 및 협력", desc: "우리는 국내외 시장을 적극적으로 개척하고 연구하며, 전략적 파트너십을 구축하여 우수한 기업 및 기관과 손잡고 게임 산업 2.0 시대로 나아갑니다. 지속적인 혁신과 고품질 서비스를 통해 글로벌 게임 문화 및 메타버스 분야에서 선도적인 브랜드 이미지를 구축하는 데 중점을 둡니다." }
    ]
  }
];

watch(() => [GlobalStyleStore.CurrentTheme, activeSection.value], () => {
  const isDark = GlobalStyleStore.CurrentTheme === Enum_Theme.Dark;
  const isHome = activeSection.value === 0;

  ThemeTopBarBackgroundColor.value = isHome ? 'transparent' : (isDark ? 'rgba(28, 28, 28, 0.57)' : 'rgba(255, 255, 255, 0.57)');
  ThemeTopBarColor.value = isDark ? '#fff' : '#484848';
  ThemeItemColor.value = isDark ? '#57E1D9' : '#f77373';

  if (isDark) {
    ThemeMainSloganColor.value = '#FFF';
    ThemeMainSloganCruxColor.value = '#57E1D9';
    ThemeSubSlogan.value = '#FFF';
    ThemeIconBackgroundColor.value = '#3fb7b0';
    ThemeIconBackgroundHoverColor.value = '#57E1D9';
    ThemeBottomBG.value = '#242424';
    ThemeBottomPartingLine.value = '#FFFFFF26';
    ThemeCopyrightFiling.value = 'rgba(255,255,255,0.6)';
    ThemeHintColor.value = 'rgba(255,255,255,0.6)';
  } else {
    ThemeMainSloganColor.value = '#545454';
    ThemeMainSloganCruxColor.value = '#f77373';
    ThemeSubSlogan.value = '#1a1a1a';
    ThemeIconBackgroundColor.value = '#de5959';
    ThemeIconBackgroundHoverColor.value = '#f77373';
    ThemeBottomBG.value = '#efefef';
    ThemeBottomPartingLine.value = 'rgba(185,185,185,0.1)';
    ThemeCopyrightFiling.value = 'rgba(0,0,0,0.6)';
    ThemeHintColor.value = 'rgba(0,0,0,0.6)';
  }
}, { immediate: true });

function scrollToSection(index: number) {
  if (scrollContainer.value) {
    const section = scrollContainer.value.querySelector(`#section-${index}`);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

let observer: IntersectionObserver | null = null;
const allAnnouncements = ref<any[]>([]);
const topAnnouncements = ref<any[]>([]);

onMounted(async () => {
  const options = { root: scrollContainer.value, rootMargin: '0px', threshold: 0.5 };
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const idParts = entry.target.id.split('-');
        if (idParts.length === 2) {
          activeSection.value = parseInt(idParts[1]);
        }
      }
    });
  }, options);
  document.querySelectorAll('.full-page-section').forEach(sec => observer?.observe(sec));

  const rawData = await fetchAnnouncements();
  const koList: any[] = [];

  rawData.forEach((item: any) => {
    try {
      // NOTE: 한국어 데이터 필터링 (.ko 추출)
      const titles = item.title.startsWith('{') ? JSON.parse(item.title) : { ko: item.title };
      const summaries = item.summary.startsWith('{') ? JSON.parse(item.summary) : { ko: item.summary };
      const contents = item.content.startsWith('{') ? JSON.parse(item.content) : { ko: item.content };
      const authors = item.author && item.author.startsWith('{') ? JSON.parse(item.author) : { ko: item.author || '' };

      if(titles.ko) {
        koList.push({
          ...item,
          title: titles.ko,
          summary: summaries.ko || '',
          author: authors.ko || '',
          content: contents.ko || ''
        });
      }
    } catch(error) {
      console.warn("JSON 파싱 실패, 손상된 데이터일 수 있습니다.", error);
    }
  });

  allAnnouncements.value = koList;
  topAnnouncements.value = koList.slice(0, 3);

  // URL 파라미터를 확인하여 뉴스 모달을 직접 열기
  const newsId = route.query.news_id;
  if (newsId) {
    const targetNews = allAnnouncements.value.find(item => String(item.id) === String(newsId));
    if (targetNews) {
      // DOM 마운트가 완료되도록 잠시 대기 후 스크롤 및 모달 오픈
      setTimeout(() => {
        activeSection.value = 2; // 내비게이션 활성 상태 강제 설정
        scrollToSection(2);      // 뉴스 섹션으로 스크롤
        openAnnouncementModal(targetNews);
      }, 500);
    }
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

const isAllListModalVisible = ref(false);

const gameList = ref([
  {
    id: 1,
    titleCHS: '성몽기행・역회의 꿈',
    titleEN: 'Star Reverie · Greystasis',
    desc: [
      '잿빛 영역이 확산되고 이몽증이 기승을 부리면서 인류의 안식처가 빠르게 붕괴하고 있습니다.',
      '주인공은 우연한 계기로 「닉토포로스」에 합류하여 서약자가 됩니다. 동료들과 함께 위기를 극복하고 다른 사람들을 도우며 자신의 과거를 찾아가는 동안, 주인공은 세상의 진실에 조용히 다가갑니다.',
      '하지만 희망의 상징이었던 「꿈의 근원」마저 진홍빛으로 물들고, 악몽이 밀물처럼 현실을 삼켜버릴 때 시간은 얼마 남지 않았습니다. 운명과 꿈을 담은 그릇은 깨지기 직전이며, 신의 피가 마침내 지상으로 쏟아져 내릴 것입니다——'
    ],
    highlight: '재시작, 혹은 종언.',
    kvPath: '/Images/Games/Star Reverie/StarReverieKV.png',
    iconPath: '/Images/Games/Star Reverie/StarReverieIcon.png'
  }
]);
const currentGameIndex = ref(0);

function OnUserClickLogo() {
  if (GlobalStyleStore.CurrentTheme === Enum_Theme.Dark) {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Light);
  } else {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Dark);
  }
}

async function OnCLickEmail() {
  try {
    await navigator.clipboard.writeText("info@lesjeuxa.com");
    alert("이메일 주소가 클립보드에 복사되었습니다. 많은 연락 바랍니다! (๑′ᴗ‵๑)❤");
  } catch (error) {
    console.error("복사 실패", error);
  }
}

function OnCLickX() {
  window.open("https://x.com", "_blank");
}

function OnCLickWeiBo() {
  window.open("https://weibo.com/", "_blank");
}

function OnCLickBilibili() {
  window.open("https://www.bilibili.com/", "_blank");
}

function OnCLickYoutuber() {
  window.open("https://www.youtube.com/@lesjeuxa", "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Dark)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: "/Images/Logo.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true),
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Light)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: "/Images/Logo_1.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["NavBar", { 'hide-on-home': activeSection.value === 0 }])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['홈', '게임 정보', '새소식', '회사 소개', '인재 영입'], (item, index) => {
            return _createElementVNode("span", {
              key: index,
              class: _normalizeClass(["nav-item", { active: activeSection.value === index }]),
              onClick: ($event: any) => (scrollToSection(index))
            }, _toDisplayString(item), 11, _hoisted_5)
          }), 64))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["Login", { 'hide-on-home': activeSection.value === 0 }])
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "item" }, "회원가입", -1),
          _createElementVNode("span", { class: "separator" }, "|", -1),
          _createElementVNode("span", { class: "item" }, "로그인", -1)
        ]))], 2)
      ])
    ]),
    _createElementVNode("div", {
      class: "ScrollContainer",
      ref_key: "scrollContainer",
      ref: scrollContainer
    }, [
      _createElementVNode("section", {
        id: "section-0",
        class: "full-page-section home-section",
        onMousemove: onHomeMouseMove,
        onMouseleave: onHomeMouseLeave
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeBgLayers.value, (layerStyle, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "home-parallax-bg",
            style: _normalizeStyle(layerStyle)
          }, null, 4))
        }), 128)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "home-vignette-overlay" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (n) => {
            return _createElementVNode("div", {
              class: "particle",
              key: n
            })
          }), 64))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "overlay",
          style: {"z-index":"10"}
        }, null, -1)),
        _createElementVNode("div", {
          class: "scroll-hint",
          style: {"z-index":"11","cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToSection(1)))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("p", null, "아래로 스크롤하여 더 보기", -1),
          _createElementVNode("div", { class: "arrow-down" }, null, -1)
        ]))])
      ], 32),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["product-container", { 'is-active': activeSection.value === 1 }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(gameList.value[currentGameIndex.value].titleEN.toUpperCase()) + " ", 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _cache[10] || (_cache[10] = _createTextVNode(" LESJEUXA", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createElementBlock("img", {
                src: gameList.value[currentGameIndex.value].kvPath,
                class: "product-kv",
                key: currentGameIndex.value
              }, null, 8, _hoisted_11))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h1", _hoisted_13, _toDisplayString(gameList.value[currentGameIndex.value].titleCHS), 1),
            _createElementVNode("h3", _hoisted_14, _toDisplayString(gameList.value[currentGameIndex.value].titleEN), 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value[currentGameIndex.value].desc, (paragraph, i) => {
                return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(paragraph), 1))
              }), 128)),
              _createElementVNode("p", _hoisted_16, _toDisplayString(gameList.value[currentGameIndex.value].highlight), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value, (game, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: game.id,
                class: _normalizeClass(["game-list-item", { 'is-selected': currentGameIndex.value === index }]),
                onClick: ($event: any) => (currentGameIndex.value = index)
              }, [
                _createElementVNode("img", {
                  src: game.iconPath
                }, null, 8, _hoisted_19)
              ], 10, _hoisted_18))
            }), 128))
          ])
        ], 2)
      ]),
      _createElementVNode("section", {
        id: "section-2",
        class: _normalizeClass(["full-page-section content-section", { 'is-active': activeSection.value === 2 }])
      }, [
        (topAnnouncements.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topAnnouncements.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "anim-item",
                  style: _normalizeStyle({ 'transition-delay': `${index * 0.2}s` })
                }, [
                  _createVNode(InfoBox_Left, {
                    Title: item.title,
                    Summary: item.summary,
                    ImagePath: item.cover_image,
                    onOpenModal: ($event: any) => (openAnnouncementModal(item))
                  }, null, 8, ["Title", "Summary", "ImagePath", "onOpenModal"])
                ], 4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("p", null, "최신 뉴스가 없습니다", -1)
            ]))])),
        (allAnnouncements.value.length > 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "more-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isAllListModalVisible.value = true))
            }, [...(_cache[12] || (_cache[12] = [
              _createTextVNode(" More ", -1),
              _createElementVNode("span", null, "+", -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("section", {
        id: "section-3",
        class: _normalizeClass(["full-page-section content-section learn-us-section", { 'is-active': activeSection.value === 3 }])
      }, [
        _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"about-header-slogan\" data-v-422e4b6e><h1 class=\"brand-core-slogan\" data-v-422e4b6e><span class=\"highlight-cyan\" data-v-422e4b6e>기술</span>개발 • <span class=\"highlight-cyan\" data-v-422e4b6e>예술</span>창조 • <span class=\"highlight-cyan\" data-v-422e4b6e>신문화</span>전파 </h1><p class=\"brand-core-desc\" data-v-422e4b6e> LESJEUXA는 최첨단 기술과 예술적 미학의 결합에 전념하며, 디지털 시대에 걸맞은 독보적인 「유시 솔루션」을 제공합니다. </p></div>", 1)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(aboutTabsData, (tab, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(["about-nav-card", { 'is-active': activeAboutTab.value === index }]),
                onClick: ($event: any) => (activeAboutTab.value = index)
              }, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(tab.num), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(tab.title), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(tab.subTitle), 1)
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-glow-bar" }, null, -1))
              ], 10, _hoisted_24)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(), _createElementBlock("div", {
              class: "details-viewport",
              key: activeAboutTab.value
            }, [
              _createElementVNode("h2", _hoisted_30, _toDisplayString(aboutTabsData[activeAboutTab.value].title) + " 요강", 1),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "viewport-divider" }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutTabsData[activeAboutTab.value].paragraphs, (para, pIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pIdx,
                  class: "content-row",
                  style: _normalizeStyle({ 'animation-delay': `${pIdx * 0.15}s` })
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "row-indicator" }, null, -1)),
                    _createElementVNode("h4", _hoisted_32, _toDisplayString(para.label), 1)
                  ]),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(para.desc), 1)
                ], 4))
              }), 128))
            ]))
          ])
        ])
      ], 2),
      _createElementVNode("section", {
        id: "section-4",
        class: "full-page-section end-section"
      }, [
        _createElementVNode("div", { class: "join-content" }, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "join-text-group" }, [
            _createElementVNode("h2", { class: "join-title" }, [
              _createTextVNode("인재 영입 / "),
              _createElementVNode("span", { class: "highlight-text" }, "JOIN US")
            ]),
            _createElementVNode("p", { class: "join-subtitle" }, "우리와 함께 다음 꿈을 펼쳐나갈 재능 있는 당신을 기다립니다.")
          ], -1)),
          _createElementVNode("div", {
            class: "contact-wrapper",
            onClick: OnCLickEmail
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("div", { class: "contact-label" }, "MAIL TO US", -1),
            _createElementVNode("div", { class: "contact-email" }, "info@lesjeuxa.com", -1),
            _createElementVNode("div", { class: "contact-hover-line" }, null, -1),
            _createElementVNode("div", { class: "contact-hint" }, "CLICK TO COPY / 이메일 주소 복사하기", -1)
          ]))])
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "BottomBG" }, [
          _createElementVNode("div", { class: "BottomPartingLine" }),
          _createElementVNode("div", { class: "BottomContent" }, [
            _createElementVNode("div", { class: "CopyrightFiling" }, "Copyright 2021-2026 LESJEUXA.COM LESJEUXA CO., LTD.")
          ])
        ], -1))
      ])
    ], 512),
    _createVNode(AnnouncementModal, {
      visible: isModalVisible.value,
      announcement: currentAnnouncementData.value,
      onClose: closeAnnouncementModal
    }, null, 8, ["visible", "announcement"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isAllListModalVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isAllListModalVisible.value = false))
                }, [
                  _createVNode(_unref(AnOutlinedClose))
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("h2", { style: {"color":"black","margin-bottom":"30px"} }, "전체 뉴스", -1)),
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAnnouncements.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "simple-list-item",
                      key: item.id,
                      onClick: ($event: any) => (openAnnouncementModal(item))
                    }, [
                      _createElementVNode("img", {
                        src: item.cover_image,
                        class: "slim-cover"
                      }, null, 8, _hoisted_38),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, _toDisplayString(item.summary), 1)
                      ])
                    ], 8, _hoisted_37))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", {
      class: "global-scroll-hint",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollToSection(activeSection.value + 1)))
    }, [...(_cache[21] || (_cache[21] = [
      _createElementVNode("div", { class: "arrow-down" }, null, -1)
    ]))], 512), [
      [_vShow, activeSection.value > 0 && activeSection.value < 4]
    ])
  ]))
}
}

})